module.exports = __webpack_public_path__ + "static/media/fail.c8a4c939.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Shared/fail.svg
// module id = 1438
// module chunks = 2